"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownCore = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = require("prop-types");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _useOutsideClick = require("../../helpers/useOutsideClick");

var _offsets = require("./offsets");

var _loadStyles = _interopRequireDefault(require("load-styles"));

var _reactTransitionGroup = require("react-transition-group");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

(0, _loadStyles.default)(":root{--tooltip-scale:0.1}.ce58aea8b{display:block}.c2b353576{position:absolute;z-index:999}.c92edc384{opacity:0;-webkit-transform:scale(.1);transform:scale(.1);-webkit-transform:scale(.1);-webkit-transform:scale(var(--tooltip-scale));transform:scale(.1);transform:scale(var(--tooltip-scale))}.cad1524d4{opacity:1;-webkit-transform:translateX(0);transform:translateX(0);transition:opacity .3s,-webkit-transform .3s;transition:opacity .3s,transform .3s;transition:opacity .3s,transform .3s,-webkit-transform .3s}.cadf1ba6a{text-align:center}");
var styles = {
  root: 'ce58aea8b',
  dropdown: 'c2b353576',
  tooltipEnter: 'c92edc384',
  tooltipEnterActive: 'cad1524d4',
  centerContent: 'cadf1ba6a'
};

var DropdownCore = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var onOverlayClick = props.onOverlayClick,
      children = props.children,
      active = props.active,
      classes = props.classes,
      position = props.position,
      portalTarget = props.portalTarget,
      direction = props.direction,
      offsetTarget = props.offsetTarget,
      customOffsetLeft = props.customOffsetLeft,
      customOffsetRight = props.customOffsetRight,
      animated = props.animated,
      animationTimeout = props.animationTimeout;
  var cn = (0, _useStyles.useStyles)(styles, classes);

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      containerNode = _useState2[0],
      setContainerNode = _useState2[1];

  var innerDropdownRef = (0, _react.useRef)(null);
  var dropdownRef = ref || innerDropdownRef;
  var containerRef = (0, _react.useCallback)(function (node) {
    if (node) setContainerNode(node);
  }, []);
  var outsideClickHandler = (0, _react.useMemo)(function () {
    return (0, _useOutsideClick.getOutsideClickHandler)(dropdownRef, onOverlayClick);
  }, [dropdownRef, onOverlayClick]);
  var style = (0, _react.useMemo)(function () {
    if (!containerNode || !active) return;
    /* container coordinates on viewport */

    var _containerNode$getBou = containerNode.getBoundingClientRect(),
        cntLeft = _containerNode$getBou.left,
        cntRight = _containerNode$getBou.right,
        cntTop = _containerNode$getBou.top,
        cntBottom = _containerNode$getBou.bottom;
    /* window scroll position */


    var _window = window,
        pageXOffset = _window.pageXOffset,
        pageYOffset = _window.pageYOffset;
    /* body width */

    var clientWidth = portalTarget.clientWidth,
        clientHeight = portalTarget.clientHeight;
    /* custom offsets */

    var _OFFSET_MAP$offsetTar = _offsets.OFFSET_MAP[offsetTarget][position],
        offsetLeft = _OFFSET_MAP$offsetTar.offsetLeft,
        offsetRight = _OFFSET_MAP$offsetTar.offsetRight;
    var leftPosition = cntLeft + pageXOffset + parseInt(offsetLeft, 10) + customOffsetLeft;
    var POSITION_MAP = {
      left: {
        left: "calc(".concat(leftPosition > 0 ? leftPosition : 0, "px)")
      },
      right: {
        right: "calc(".concat(clientWidth - (cntRight + pageXOffset), "px + ").concat(offsetRight, " + ").concat(customOffsetRight, "px)")
      }
    };
    var DIRECTION_MAP = {
      down: {
        top: "".concat(cntBottom + pageYOffset, "px")
      },
      up: {
        bottom: "".concat(clientHeight - (cntTop + pageYOffset), "px")
      }
    };
    return _objectSpread(_objectSpread({}, DIRECTION_MAP[direction]), POSITION_MAP[position]);
  }, [containerNode, active, portalTarget, offsetTarget, customOffsetLeft, customOffsetRight, position, direction]);
  (0, _useOutsideClick.useOutsideClick)(outsideClickHandler, active);
  (0, _react.useEffect)(function () {
    if (!active) return;
    var position = portalTarget.style.position;
    portalTarget.style.position = 'relative';
    return function () {
      portalTarget.style.position = position;
    };
  }, [active, portalTarget.style.position]);
  (0, _react.useEffect)(function () {
    if (!containerNode || !active) return;

    var getListener = function getListener(node, x, y) {
      return function (event) {
        node.scrollTo(x, y);
      };
    };

    var isScrollable = function isScrollable(node) {
      var overflowY = window.getComputedStyle(node)['overflow-y'];
      var overflowX = window.getComputedStyle(node)['overflow-x'];
      var vertical = (overflowY === 'scroll' || overflowY === 'auto') && node.scrollHeight > node.clientHeight;
      var horisontal = (overflowX === 'scroll' || overflowX === 'auto') && node.scrollHeight > node.clientHeight;
      return vertical || horisontal;
    };

    var nodes = []; // [{ node, listener }]

    var node = containerNode;

    do {
      if (isScrollable(node)) {
        var initX = node.scrollLeft;
        var initY = node.scrollTop;
        var listener = getListener(node, initX, initY);
        node.addEventListener('scroll', listener);
        nodes.push({
          node: node,
          listener: listener
        });
      }

      node = node.parentNode === portalTarget ? null : node.parentNode;
    } while (node);

    return function () {
      nodes.forEach(function (_ref) {
        var node = _ref.node,
            listener = _ref.listener;
        node.removeEventListener('scroll', listener);
      });
    };
  }, [active, containerNode, portalTarget]);

  if (animated) {
    return /*#__PURE__*/_react.default.createElement("div", {
      ref: containerRef,
      className: cn.root
    }, /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
      in: active,
      timeout: animationTimeout,
      unmountOnExit: true,
      classNames: {
        enter: cn.tooltipEnter,
        enterActive: cn.tooltipEnterActive
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(cn.dropdown, cn.centerContent),
      ref: dropdownRef,
      style: style
    }, !active ? null : children)), portalTarget));
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    ref: containerRef,
    className: cn.root
  }, !active ? null : /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement("div", {
    className: cn.dropdown,
    ref: dropdownRef,
    style: style
  }, children), portalTarget));
});

exports.DropdownCore = DropdownCore;
var position = ['left', 'right'];
var direction = ['down', 'up'];
var offsetTarget = ['usual', 'iconButton'];
DropdownCore.modes = {
  position: position,
  direction: direction,
  offsetTarget: offsetTarget
};
DropdownCore.propTypes = {
  /* component logic props */
  onOverlayClick: _propTypes.func.isRequired,
  children: _propTypes.node.isRequired,
  active: _propTypes.bool,
  portalTarget: (0, _propTypes.oneOfType)([(0, _propTypes.instanceOf)(Element), (0, _propTypes.instanceOf)(HTMLDocument)]),
  offsetTarget: (0, _propTypes.oneOf)(offsetTarget),
  customOffsetLeft: _propTypes.number,
  customOffsetRight: _propTypes.number,
  animated: _propTypes.bool,
  animationTimeout: _propTypes.number,

  /* styling modificators */
  position: (0, _propTypes.oneOf)(position),
  direction: (0, _propTypes.oneOf)(direction),

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
DropdownCore.defaultProps = {
  position: 'left',
  direction: 'down',
  offsetTarget: 'usual',
  customOffsetLeft: 0,
  customOffsetRight: 0,
  active: false,
  classes: {},
  portalTarget: document.body,
  animated: false,
  animationTimeout: 200
};